import { DatePipe, DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CardModule } from 'primeng/card';
import { DividerModule } from 'primeng/divider';
import { ProgressBarModule } from 'primeng/progressbar';

@Component({
  selector: 'cosmos-temperature-insights-card',
  imports: [
    TranslatePipe, DecimalPipe, DatePipe,
    DividerModule, CardModule, ProgressBarModule,
  ],
  templateUrl: './temperature-insights-card.component.html',
  styleUrls: ['./temperature-insights-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TemperatureInsightsCardComponent {
  readonly temperatures = input<number[] | undefined>(undefined);
  readonly specifications_temperature = input<number[] | undefined>(undefined);
  readonly specifications_maturity = input<number[] | undefined>(undefined);
  readonly time = input<any>(null);
  readonly config = input<any>(null);

  readonly maxTemp = computed(() => {
    const temps = this.temperatures();
    return temps?.length ? Math.max(...temps) : null;
  });

  readonly minTemp = computed(() => {
    const temps = this.temperatures();
    return temps?.length ? Math.min(...temps) : null;
  });

  readonly average = computed(() => {
    const temps = this.temperatures();
    if (!temps?.length) return null;
    return temps.reduce((a, b) => a + b) / temps.length;
  });
}
